import { useGetProfileCardQuery } from 'src/hooks/useProfileQuery';

export const useMyProfile = () => {
  const { data } = useGetProfileCardQuery(
    { type: 'MY_PROFILE' },
    {
      staleTime: Infinity,
      gcTime: Infinity,
    }
  );

  return data;
};
